import s from "./RiskDailyTableWidget.module.scss";
import {
  riskFormatter,
  sendRequest,
  useGlobalPeriod,
  useRiskWire,
} from "@iliotech/data-wire";
import { useParams } from "react-router-dom";
import { IllioTable } from "src/main";
import React from "react";
import moment from "moment";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import classNames from "classnames";

export const RiskDailyTableWidget = ({
  isHalfHeight,
  periodContext,
}: ReportWidgetProps) => {
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const riskWire = useRiskWire({
    portfolioId: portfolioId!,
    sendRequest: sendRequest,
    frequency: "Daily",
    overridePeriod: periodContext.periodForRequest,
  });
  const { volatilityResponse } = riskWire.serverData;
  const loadingStats =
    volatilityResponse === undefined ? true : !volatilityResponse.data;
  const performanceColumn = React.useMemo(() => {
    return IllioTable.ColumnSets?.PerformanceStatsReport(loadingStats);
  }, [loadingStats]);

  const volatilityData = React.useMemo(
    () =>
      riskFormatter(
        volatilityResponse?.data,
        periodContext.periodForRequest as any,
        "Daily",
        isHalfHeight
      ),
    [volatilityResponse?.data, isHalfHeight]
  );

  const { risk, volatility, annualizationDate } = volatilityData;

  return (
    <div>
      <h6 className={classNames("element-title")}>{`Risk Daily Table`}</h6>
      <div className={classNames(s.row, isHalfHeight && s.halfHeight)}>
        <div className={s.performanceTables} data-cy="portfolioStatistics">
          {!isHalfHeight && (
            <b>{`${"Portfolio Stats (up to "}${moment(annualizationDate).format(
              "DD MMM` YY"
            )})`}</b>
          )}
          <IllioTable
            columns={performanceColumn}
            useColumnChooser={false}
            hideHeader={true}
            isPageable={false}
            loading={loadingStats}
            data={risk}
          />
          <p style={{ fontSize: "10px", marginTop: "20px", marginBottom: 10 }}>
            {"VOLATILITY"}
          </p>
          <IllioTable
            columns={performanceColumn}
            useColumnChooser={false}
            hideHeader={true}
            isPageable={false}
            loading={loadingStats}
            data={volatility}
          />
        </div>
      </div>
    </div>
  );
};
